"use client";

import React from "react";
import { Cuboid, Smartphone, Glasses } from "lucide-react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const services = [{
  title: "Infill Development",
  description: "Strategic solutions for infill builders looking to maximize urban density and property value through expert market analysis and site selection.",
  icon: Cuboid
}, {
  title: "Residential Brokerage",
  description: "Personalized guidance for home buyers and sellers, ensuring seamless transactions and the best market value for your primary residence.",
  icon: Smartphone
}, {
  title: "Commercial Investment",
  description: "High-yield investment opportunities and property management services designed to optimize portfolio performance for serious investors.",
  icon: Glasses
}];
export default function TailoredRealEstateSolutions() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="261803" id="tailored-real-estate-solutions" className="bg-background text-foreground py-24 relative overflow-hidden">
      {}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[800px] h-[800px] bg-secondary/5 rounded-md blur-[120px] pointer-events-none" />

      <div className="container mx-auto px-4 relative z-10">
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-5xl font-default text-primary mb-4 tracking-tight">
            Tailored Real Estate Solutions
          </h2>
          <p className="text-muted-foreground font-default max-w-2xl mx-auto text-lg leading-relaxed">
            Providing unparalleled value to infill builders, home buyers, and investors through architectural sophistication and market expertise.
          </p>
        </div>

        <div ref={ref} className={`grid grid-cols-1 md:grid-cols-3 gap-8 transition-all duration-1000 ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-10"}`}>
          {services.map((service, i) => {
          const Icon = service.icon;
          return <div key={i} data-index={i} className={`group relative bg-card backdrop-blur-md border border-border rounded-md p-8 transition-all duration-500 hover:-translate-y-2 hover:shadow-lg hover:border-secondary/30 flex flex-col h-full ${i === 1 ? "md:translate-y-8" : ""}`}>
                <div className="mb-6 inline-flex items-center justify-center w-16 h-16 rounded-md bg-accent text-secondary group-hover:scale-105 transition-transform duration-300">
                  <Icon className="w-10 h-10 stroke-[1.5pt]" />
                </div>
                
                <h3 className="text-2xl font-default font-bold text-foreground mb-4">
                  {service.title}
                </h3>
                
                <p className="text-muted-foreground font-default text-base leading-[1.6] flex-grow">
                  {service.description}
                </p>
                
                {}
                <div className="absolute top-0 right-0 w-16 h-16 overflow-hidden rounded-tr-md pointer-events-none">
                  <div className="absolute top-[-24px] right-[-24px] w-12 h-12 bg-secondary/10 rotate-45 blur-sm group-hover:bg-secondary/20 transition-colors duration-300" />
                </div>
              </div>;
        })}
        </div>
      </div>
    </section>;
}